import { render, staticRenderFns } from "./ShippingService.vue?vue&type=template&id=59a53c5a&scoped=true"
import script from "./ShippingService.vue?vue&type=script&lang=js"
export * from "./ShippingService.vue?vue&type=script&lang=js"
import style0 from "./ShippingService.vue?vue&type=style&index=0&id=59a53c5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a53c5a",
  null
  
)

export default component.exports